module.exports = __webpack_public_path__ + "img/manifest_mob.affa72cc.svg";